// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__CXGIo","bg-spin":"Card_bg-spin__VtIFf","income":"Card_income__t6CL9","expense":"Card_expense__Od+MF"};